import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LLMPage from './LLMPage';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/llm" element={<LLMPage />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
